<template>
	<div>
		<div class="single-post">
			<h1> {{ posts.title }} </h1>
			<img :src="posts.cover">
			<div v-html="posts.text"> {{ posts.text }} </div>
			<div class="social-sharing">
				<p>Розкажіть про це друзям:</p>
				<social-sharing :url="'https://dnz-kalynka.pp.ua/#/posts/' + posts.slug"
						:title="posts.title"
						:description="posts.text | striphtml"
						:quote="posts.text | striphtml"
						inline-template>
					<div>
						<network network="facebook">
							<i class="fa fa-facebook"></i>
						</network>
						<network network="googleplus">
							<i class="fa fa-google-plus"></i>
						</network>
						<network network="vk">
							<i class="fa fa-vk"></i>
						</network>
						<network network="odnoklassniki">
							<i class="fa fa-odnoklassniki"></i>
						</network>
						<network network="telegram">
							<i class="fa fa-telegram"></i>
						</network> 
						<network network="whatsapp">
							<i class="fa fa-whatsapp"></i>
						</network>
					</div>
				</social-sharing>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">

	module.exports = {
		data: function(){
			return {
				main: 'https://dnz-kalynka.pp.ua/api/post/',
				posts: []
			}
		},
		methods: {
			getContent: function(){
				var postId = this.$route.params.id
				this.$http.get(this.main + postId).then(function(response){
					this.posts = response.data
				}, function(error){
					console.log('Помилка при отриманні даних')
				})
			}
		},
		created: function(){
			this.getContent()
		},
		watch: {
			'$route': {
				deep: true,
					handler: function (refreshPage) {
					this.getContent()
				}
			}
		}
	}

</script>


// WEBPACK FOOTER //
// src/views/single-post.vue